import { useEffect, useMemo, useReducer } from 'react';
import { ControllerSession } from './controller.js';

export function useSession(): { session: ControllerSession; tick: number } {
  const session = useMemo(() => new ControllerSession(), []);
  const [tick, bump] = useReducer((n: number) => n + 1, 0);
  useEffect(() => {
    const off = session.subscribe(bump);
    void session.init();
    return off;
  }, [session]);
  return { session, tick };
}
